import { __extends, __assign } from 'tslib';
import React__default from 'react';
import styles from './Text.module.scss.js';
import { propTypes, defaultProps } from './Text.types.js';

var DEPRECATED_TYPES = ['sub3', 'label2', 'overline', 'legal'];
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.prototype.render = function () {
        var _a = this.props, type = _a.type, children = _a.children, className = _a.className, color = _a.color, as = _a.as;
        var typeClass = styles["Text___" + type];
        var classes = typeClass + " " + (className || '');
        if (DEPRECATED_TYPES.includes(type)) {
            console.warn(type + " is Deprecated please use a different one");
        }
        if (as !== undefined && as !== null) {
            var Component = as;
            return (React__default.createElement(Component, { className: classes, style: { color: color } }, children));
        }
        switch (type) {
            case 'h1':
                return (React__default.createElement("h1", { className: classes, style: { color: color } }, children));
            case 'h2':
                return (React__default.createElement("h2", { className: classes, style: { color: color } }, children));
            case 'h3':
                return (React__default.createElement("h3", { className: classes, style: { color: color } }, children));
            case 'h4':
                return (React__default.createElement("h4", { className: classes, style: { color: color } }, children));
            case 'h5':
                return (React__default.createElement("h5", { className: classes, style: { color: color } }, children));
            case 'h6':
                return (React__default.createElement("h6", { className: classes, style: { color: color } }, children));
            case 'sub1': // fall through
            case 'sub2': // fall through
            case 'sub3':
                return (React__default.createElement("h6", { className: classes, style: { color: color } }, children));
            case 'p': // fall through
            case 'bold': // fall through
            case 'overline': // fall through
            case 'legal':
                return (React__default.createElement("p", { className: classes, style: { color: color } }, children));
            case 'primarybtn':
            case 'tertiarybtn':
            case 'hyperlink':
            case 'number':
                return (React__default.createElement("span", { className: classes, style: { color: color } }, children));
            case 'label1': // fall through
            case 'label2':
                return (React__default.createElement("label", { className: classes, style: { color: color } }, children));
            default:
                return (React__default.createElement("p", { className: classes, style: { color: color } }, children));
        }
    };
    Text.displayName = 'Text';
    Text.propTypes = propTypes;
    Text.defaultProps = __assign({}, defaultProps);
    return Text;
}(React__default.Component));

export default Text;
